<template>
<el-dialog :title="viewFlag === 'view' ? '查看' : !dataForm.id ? '新增' : '修改'" width="55%" :append-to-body="true" :close-on-click-modal="false" :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" class="code-type-dialog-form" size="mini">
        <div class="des_box">
            <el-descriptions class="margin-top" :column="2" size="small" border style="margin-bottom: 15px;">
                <!-- <el-descriptions-item label="第几轮报价" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="roundNo" style="margin-bottom: 0;">
                        <span>{{dataForm.roundNo}}</span>
                    </el-form-item>
                </el-descriptions-item> -->
                <el-descriptions-item label="零件编码" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partCode" style="margin-bottom: 0;">
                        <el-input size="mini" v-if="viewFlag !== 'view'" v-model="dataForm.partCode" placeholder="请输入零件编码" clearable></el-input>
                        <span v-else>{{dataForm.partCode}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="零件名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="partName" style="margin-bottom: 0;">
                        <el-input size="mini" v-if="viewFlag !== 'view'" v-model="dataForm.partName" placeholder="请输入零件名称" clearable></el-input>
                        <span v-else>{{dataForm.partName}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="工序名称" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="processName" style="margin-bottom: 0;">
                        <el-input size="mini" v-if="viewFlag !== 'view'" v-model="dataForm.processName" placeholder="请输入工序名称" clearable></el-input>
                        <span v-else>{{dataForm.processName}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="每小时产量" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="outputPerHour" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.outputPerHour" placeholder="每小时产量"></ctl-number>
                        <span v-else>{{this.fixedNumber(dataForm.outputPerHour)}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="设备吨位" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="equipmentTonnage" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.equipmentTonnage" placeholder="设备吨位"></ctl-number>
                        <span v-else>{{this.fixedNumber(dataForm.equipmentTonnage)}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="劳务费" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="laborFee" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.laborFee" placeholder="劳务费"></ctl-number>
                        <span v-else>{{this.fixedNumber(dataForm.laborFee)}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="设备折旧费" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="equipmentDepreciation" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.equipmentDepreciation" placeholder="设备折旧费"></ctl-number>
                        <span v-else>{{this.fixedNumber(dataForm.equipmentDepreciation)}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="加工成本" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="processingCost" style="margin-bottom: 0;">
                        <!-- <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.processingCost" placeholder="加工成本"></ctl-number> -->
                        <span>{{this.fixedNumber(dataForm.processingCost)}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="合计" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="total" style="margin-bottom: 0;">
                        <!-- <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.total" placeholder="合计"></ctl-number> -->
                        <span>{{this.fixedNumber(dataForm.total)}}</span>
                    </el-form-item>
                </el-descriptions-item>
                <el-descriptions-item label="其他" :label-style="getStyle()" :content-style="getStyle2()">
                    <el-form-item prop="other" style="margin-bottom: 0;">
                        <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="dataForm.other" type="textarea" :rows="3" placeholder="其他"></ctl-number>
                        <span v-else>{{this.fixedNumber(dataForm.other)}}</span>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>
        </div>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="view.visible = false">
            <span class="font-12 iconfont myicon-quxiao1"></span>&nbsp;取消
        </el-button>
        <el-button size="mini" type="primary" v-if="viewFlag != 'view'" plain @click="dataFormSubmit()">
            <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;确定
        </el-button>
    </span>
</el-dialog>
</template>

<script>
import {
    createProcessCost,
    getProcessCostById,
    editProcessCost,
    getRfqBaseById
} from "@/controller/quotation";
import {
    PROCESSNAME_VALUE,
    getProcessNameByValue
} from '@/utils/const'
import {
    mapping
} from "@/utils"
import CtlNumber from '@/views/common/ctl-number'
export default {
    components: {
        CtlNumber
    },
    data() {
        return {
            view: {
                visible: false,
                conheight: {
                    height: this.$store.state.common.documentClientDefaultHeight *
                        0.9 -
                        410 +
                        "px",
                    "overflow-y": "auto",
                },
            },
            viewFlag: '',
            viewData: {},
            PROCESSNAME_VALUE: PROCESSNAME_VALUE,
            getProcessNameByValue: getProcessNameByValue,
            dataForm: {
                id: 0,
                partCode:'',
                partName:'',
                rfqId: '',
                rfqPartId: '',
                rfqSupplierId: '',
                appartmentId: "",
                supplierId: "",
                roundNo: "",
                processName: "",
                outputPerHour: "",
                equipmentTonnage: "",
                laborFee: "",
                equipmentDepreciation: "",
                other: "",
                total: "",
                processingCost: "",
            },
            // 开始
            dataRule: {
                name: [{
                    required: true,
                    message: "编码名称不能为空",
                    trigger: "blur",
                }, ],
                type: [{
                    required: true,
                    message: "编码类型不能为空",
                    trigger: "blur",
                }, ],
            },
        };
    },
    methods: {
        // 初始化
        init(id, viewFlag, data, rfqId) {
            // debugger;
            mapping(data, this.dataForm)
            this.dataForm.id = id || 0;
            this.dataForm.rfqId = rfqId
            this.viewFlag = viewFlag
            // this.dataForm.technicalNotifId = technicalNotifId;
            this.view.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.id) {
                    // 根据id查单条
                    getProcessCostById({}, this.dataForm.id).then((data) => {
                        if (data && data.code === "00") {
                            this.dataForm = data.body;
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    debugger
                    getRfqBaseById({}, this.dataForm.rfqId).then(data => {
                        if (data && data.code === '00') {
                            if("2" != data.body.rfqStatus) {
                                this.$message.warning("询价单不是询价中状态，不允许修改报价相关信息")
                            } else {
                                let Params = {
                                    id: this.fixedNumber(this.dataForm.id),
                                    partCode:this.dataForm.partCode,
                                    partName:this.dataForm.partName,
                                    rfqId: this.fixedNumber(this.dataForm.rfqId),
                                    rfqPartId: this.fixedNumber(this.dataForm.rfqPartId),
                                    rfqSupplierId: this.fixedNumber(this.dataForm.rfqSupplierId),
                                    appartmentId: this.fixedNumber(this.dataForm.appartmentId),
                                    supplierId: this.fixedNumber(this.dataForm.supplierId),
                                    roundNo: this.fixedNumber(this.dataForm.roundNo),
                                    processName: this.dataForm.processName,
                                    outputPerHour: this.fixedNumber(this.dataForm.outputPerHour),
                                    equipmentTonnage: this.fixedNumber(this.dataForm.equipmentTonnage),
                                    laborFee: this.fixedNumber(this.dataForm.laborFee),
                                    equipmentDepreciation: this.fixedNumber(this.dataForm.equipmentDepreciation),
                                    other: this.fixedNumber(this.dataForm.other),
                                    total: this.fixedNumber(this.dataForm.total),
                                    processingCost: this.fixedNumber(this.dataForm.processingCost)
                                };
                                console.log("Params:",Params)
                                if (this.dataForm.id) {
                                    // 更新零件
                                    editProcessCost(Params)
                                        .then((data) => {
                                            if (data && data.code === "00") {
                                                this.$message({
                                                    message: "操作成功",
                                                    type: "success",
                                                    duration: 1500,
                                                    onClose: () => {
                                                        this.view.visible = false;
                                                        this.$emit("refreshDataList");
                                                        this.$emit("getDataListAll");
                                                    },
                                                });
                                            } else {
                                                this.$message.error(data.msg);
                                            }
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                } else {
                                    // 创建零件
                                    createProcessCost(Params)
                                        .then((data) => {
                                            if (data && data.code === "00") {
                                                this.$message({
                                                    message: "操作成功",
                                                    type: "success",
                                                    duration: 1500,
                                                    onClose: () => {
                                                        this.view.visible = false;
                                                        this.$emit("refreshDataList");
                                                        this.$emit("getDataListAll");
                                                    },
                                                });
                                            } else {
                                                this.$message.error(data.msg);
                                            }
                                        })
                                        .catch((error) => {
                                            console.log(error);
                                        });
                                }
                            }
                        }
                    })
                }
            });
        },
        fixedNumber(val) {
            if (!val || isNaN(val)) {
                return null
            }
            return Number(Number(val).toFixed(3))
        },
        getStyle() {
            return 'width: 170px; text-align: right'
        },
        getStyle2() {
            return 'width: 587.5px;'
        }
    },
};
</script>

<style lang="scss">
.el-dialog__body {
    .code-type-dialog-form {
        width: 100%;
    }
}
</style>
